exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar[data-v-bb1920de]{height:60px;overflow:hidden;position:relative;border-bottom:1px solid #dcdfe6;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
